import React from 'react';
import { TESTIMONIALS } from '../../data/testimonials';
import './Testimonials.css';

// Real customer quotes (data/testimonials.js). Renders nothing when there are
// none, so the homepage never shows placeholder or invented praise.
const Testimonials = ({ items = TESTIMONIALS }) => {
  const quotes = (items || []).filter((t) => t && t.quote && t.name);
  if (quotes.length === 0) return null;
  return (
    <section className="home-testimonials" aria-labelledby="home-testimonials-title">
      <h2 id="home-testimonials-title" className="home-testimonials-title">What hosts say</h2>
      <div className="home-testimonials-grid">
        {quotes.slice(0, 3).map((t) => (
          <figure key={t.name} className="home-testimonial">
            <blockquote>“{t.quote}”</blockquote>
            {t.result && <p className="home-testimonial-result">{t.result}</p>}
            <figcaption>
              {t.photo && <img src={t.photo} alt="" width="40" height="40" loading="lazy" />}
              <span>
                <strong>{t.name}</strong>
                {t.role && <span className="home-testimonial-role">{t.role}</span>}
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
